import { Maybe } from "true-myth";

import { MODAL_STATUS } from "actions/scheduling";
import { IBlockModalData } from "components/schedule/time_block_modal";

import { IBrandGroup, IDayPart, ISalesForecast } from "types/account";
import { RequestStatus } from "types/requests";
import { ISchedule, IUnavailabilityBlock, IPosUser } from "types/schedules";
import { ITemplate } from "types/templates";
import { LDFlags } from "interfaces/context";

export interface IContextState {
  featureFlags: LDFlags;
  flagStatus: RequestStatus;
}

export interface IUserState {
  userRequestStatus: RequestStatus;
  email: string;
  firstName: Maybe<string>;
  lastName: Maybe<string>;
}

export interface ICategoryRoles {
  [key: string]: string[];
}

export interface IScheduleFilters {
  roles: string[];
}

export enum SchedulingApiRequests {
  NOTIFY_POST = "notifySchedulePost",
  POS_USERS_GET = "posUsersGet",
  PUBLISHED_GET = "publishedScheduleGet",
  PUBLISH_POST = "publishSchedulePost",
  DRAFT_GET = "draftScheduleGet",
  DRAFT_POST = "draftSchedulePost",
  UNAVAIL_GET = "unavailGet",
  UNAVAIL_POST = "unavailPost",
  UNAVAIL_DELETE = "unavailDelete",
}

export interface IUsersByUuid {
  [key: string]: IPosUser;
}

export interface ISchedulingState {
  schedule: ISchedule;
  autoSaveIntervalId: number;
  draft: Maybe<ISchedule>;
  published: Maybe<ISchedule>;
  users: IUsersByUuid;
  unavailBlocks: IUnavailabilityBlock[];
  requestStatuses: { [key in SchedulingApiRequests]: RequestStatus };
  showNotifyScheduleModal: MODAL_STATUS;
  timeBlockModalData: Maybe<IBlockModalData>;
}

export interface ISettingsRequests {
  enforcementRequestStatus: RequestStatus;
  enforcementPostStatus: RequestStatus;
}

export interface ISettingsState {
  requests: ISettingsRequests;
  enforcementOn: boolean;
  gracePeriod: number;
}

export interface ITemplatesKeyed {
  [key: string]: ITemplate;
}

export enum TemplateApiRequests {
  POST = "postTemplate",
  GET = "getTemplates",
  DELETE = "deleteTemplate",
}

export interface ITemplatesState {
  templates: ITemplatesKeyed;
  requestStatuses: { [key in TemplateApiRequests]: RequestStatus };
}

export interface IAccountRequests {
  salesForecastGet: RequestStatus;
  dayPartsPost: RequestStatus;
  locationsGet: RequestStatus;
}

export interface IAccountState {
  salesForecast: Maybe<ISalesForecast>;
  dayParts: IDayPart[];
  locations: IBrandGroup[];
  permalink: Maybe<string>;
  requestStatuses: IAccountRequests;
}

export interface IRootStateProps {
  account: IAccountState;
  filters: IScheduleFilters;
  scheduling: ISchedulingState;
  settings: ISettingsState;
  templates: ITemplatesState;
  user: IUserState;
  context: IContextState;
}
